module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content login-wrapper"
  }, [_c('div', {
    staticClass: "content-inner loginBox"
  }, [_c('div', {
    staticClass: "flex-column full-w centered"
  }, [(_vm.maintenance) ? _c('el-alert', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "title": "Site on maintenance mode. Login is disabled",
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "min-width-300 max-width-300"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/images/kundan-logo.png"),
      "width": "200px"
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('static.login.title')))]), _vm._v(" "), (_vm.form.errorBox) ? _c('el-alert', {
    attrs: {
      "title": _vm.form.errorBoxTitle || _vm.$t('static.login.errorBoxTitle'),
      "type": "error",
      "closable": false
    }
  }) : _vm._e(), _c('br'), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "btn-text": "button.login",
      "translation": "form.login"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.form.loading,
      "disabled": _vm.maintenance
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('button.login')) + "\n              ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "forgot-password"
  }, [(false) ? _c('router-link', {
    staticClass: "buttons_login",
    attrs: {
      "to": {
        name: 'home.index'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.login.newUser')))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'auth.resetPassword'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('static.login.forgotPassword')))])], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c458a1c","hasScoped":false}!./src/app/pages/auth/login/login.html
// module id = 3025
// module chunks = 1